import { Injectable } from '@angular/core';

@Injectable()
export class GridMetadataService {
    private columns: Object = {
        LateAssets: {
            Oid: { type: 'long', required: true, hide: true },
            Name: { type: 'string', name: 'Asset Type', width: 200 },
            Current: { type: 'int', name: 'Current', width: 200 },
            Aged30: { type: 'int', name: 'Aged 30', width: 200 },
            Aged60: { type: 'int', name: 'Aged 60', width: 200 },
            Aged90: { type: 'int', name: 'Aged 90', width: 200 }
        },

        LateAssetsDetail: {
            Oid: { type: 'long', required: true, hide: true },
            EntityFullName: { type: 'string', name: 'Member', width: 200 },
            asset_IdNumber: { type: 'string', name: 'Call Number', width: 200 },
            CheckOutDate: { type: 'ShortDate', name: 'Check Out Date', width: 150 },
            DueDate: { type: 'ShortDate', name: 'Due Date', width: 100 },
            DaysLate: { type: 'int', name: 'Days Past Due', width: 150 }
        },

        MediaSearchResults: {
            Oid: { type: 'long', required: true, hide: true },
            lkpAssetStatusOid:  { type: 'mediaSearchResultsStatus', name: 'Status', width: 100 }, 
            Speaker_Artist_Author: { type: 'string', name: 'Author/Artist/Speaker', width: 150 },
            Title: { type: 'string', name: 'Title', width: 400 },
            AssetType: { type: 'string', name: 'Type', width: 100 },
            IdNumber: { type: 'string', name: 'Call Number', width: 100 },
            BarcodeId: { type: 'string', name: 'Barcode ID', width: 100 },            
        },

        MemberSearchResults: {
            Oid: { type: 'long', required: true, hide: true },
            BarcodeId: { type: 'long', name: 'Barcode', width: 100 },
            FirstName: { type: 'string', name: 'First Name', width: 100 },
            LastName: { type: 'string', name: 'Last Name', width: 100 },
            Email: { type: 'string', name: 'Email', width: 300 },
            FullAddress: { type: 'memberSearchResultsAddress', name: 'Address', width: 500 }
        },

        MemberCheckoutHistory: {
            Oid: { type: 'long', required: true, hide: true },
            Title: { type: 'checkOutHistoryTitle', name: 'Title', width: 200 },
            CheckOutDate: { type: 'ShortDate', name: 'Check Out Date', width: 150 },
            DueDate: { type: 'ShortDate', name: 'Due Date', width: 100 },
            CheckInDate: { type: 'ShortDate', name: 'Check In Date', width: 150 },
            Type: { type: 'checkOutHistoryAssetType', name: 'Media Type', width: 100 },
            IdNumber: { type: 'checkOutHistoryCallNumber', name: 'Call Number', width: 100 },
            BarcodeId: { type: 'checkOutHistoryBarcodeID', name: 'Barcode ID', width: 100 },
        },

        MemberCurrentlyCheckedOut: {
            Oid: { type: 'long', required: true, hide: true },
            Title: { type: 'checkOutHistoryTitle', name: 'Title', width: 200 },
            CheckOutDate: { type: 'ShortDate', name: 'Check Out Date', width: 150 },
            DueDate: { type: 'ShortDate', name: 'Due Date', width: 100 },
            Type: { type: 'checkOutHistoryAssetType', name: 'Media Type', width: 100 },
            IdNumber: { type: 'checkOutHistoryCallNumber', name: 'Call Number', width: 100 },
            BarcodeId: { type: 'checkOutHistoryBarcodeID', name: 'Barcode ID', width: 100 },
            Renew: { type: 'assetRenewBtn', name: ''},
        },

        SpineLabels: {
            Oid: { type: 'long', required: true, hide: true },
            Speaker_Artist_Author: { type: 'string', name: 'Author/Artist/Speaker', width: 150 },
            Title: { type: 'string', name: 'Title', width: 400 },
            AssetType: { type: 'string', name: 'Type', width: 100 },
            IdNumber: { type: 'string', name: 'Call Number', width: 100 } 
        }
    };

    private resourceName: Object = {
    };

    constructor( ) { }

    public describe(tableName, columnNames) {
        if (this.columns[tableName] === undefined) {
            console.error('No columns found for table: ' + tableName );
        }

        let columns = [];

        columns.push({
            name: '#',
            field: 'num',
            behavior: 'select',
            cssClass: 'cell-selection',
            width: 40,
            showOnForm: false,
            cannotTriggerInsert: true,
            resizable: false,
            selectable: false
        });

        if (columnNames === null) {
            columnNames = Object.getOwnPropertyNames(this.columns[tableName]);
        }

        for (let i in columnNames) {
            let column = this.columns[tableName][columnNames[i]];
            column['field'] = columnNames[i];

            if (!column['hide']) {
                columns.push(column);
            }
        }

        let result = {
            name: tableName,
            title: tableName,
            resource: '',
            columns: columns,
        };

        return result;
    }
}



// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/clearwave-grid/grid.metadata.service.ts